import { render, staticRenderFns } from "./videoSet.vue?vue&type=template&id=b478486e&"
import script from "./videoSet.vue?vue&type=script&lang=js&"
export * from "./videoSet.vue?vue&type=script&lang=js&"
import style0 from "./videoSet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports